export default {
  grammarTotal: { en: "Grammar total", pt: "Total de gramáticas" },
  machineTotal: { en: "Machine total", pt: "Total de máquinas" },
  generalTotal: { en: "Total", pt: "Total" },
  email: { en: "Email", pt: "E-mail" },
  report: { en: "Reports", pt: "Relatório" },
  name: { en: "Name", pt: "Nome" },
  search: { en: "Search", pt: "Pesquisar" },
  lastUsers: { en: "Last x users", pt: "Últimos x usuários" },
  lastAccess: { en: "Last Access", pt: "Último acesso" },
};
